import { render, staticRenderFns } from "./TenancyDepositRelease.vue?vue&type=template&id=881d11ae&"
import script from "./TenancyDepositRelease.vue?vue&type=script&lang=js&"
export * from "./TenancyDepositRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports